import _slicedToArray from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _styled from "styled-components";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as HomeIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/forcehome.svg";
import { ReactComponent as PauseCircleIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/pause.svg";
import { ReactComponent as PauseIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/pause2.svg";
import { ReactComponent as VacationIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/airplane.svg";
import { ReactComponent as OkayIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/successcircle.svg";
import { ReactComponent as CalendarIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/calendar.svg";
import { ReactComponent as SheduleIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/calendarbadge.svg";
import { formatTemperature } from "../../../utils/formatTemperature";
import { useDeviceApi } from "../../DeviceData/useDeviceApi";
import { ConfirmModal } from "./ConfirmModal";
import { ConfirmButton } from "./ConfirmButton";
import { ToggleButton } from "./ToggleButton";
var iconColorDisabled = "rgba(0, 0, 0, 0.2)";
var iconColorActive = "white";
var iconColorDefault = "black";

function chooseColor(disabled, active) {
  if (disabled) {
    return iconColorDisabled;
  }

  if (active) {
    return iconColorActive;
  }

  return iconColorDefault;
}

var ToggleGroupContainer = _styled.div.withConfig({
  displayName: "ToggleGroup__ToggleGroupContainer",
  componentId: "h2bm5t-0"
})(["width:300px;display:flex;justify-content:", ";align-items:center;"], function (props) {
  return props.manualMode ? "center" : "space-between";
});

var ContainerTwoIcon = _styled.div.withConfig({
  displayName: "ToggleGroup__ContainerTwoIcon",
  componentId: "h2bm5t-1"
})(["position:relative;"]);

var SheduleIconContainer = _styled.div.withConfig({
  displayName: "ToggleGroup__SheduleIconContainer",
  componentId: "h2bm5t-2"
})(["position:absolute;left:53px;"]);

var iconSize = 50;

var StyledLink = _styled(Link).withConfig({
  displayName: "ToggleGroup__StyledLink",
  componentId: "h2bm5t-3"
})(["&,&:hover,&:active{color:black;text-decoration:none;}"]);

var sizeSmallIconModal = 15;
var sizeIconModal = 60;
export function ToggleGroup(_ref) {
  var heatConfig = _ref.heatConfig,
      heatMode = _ref.heatMode,
      deviceId = _ref.deviceId;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      openedModal = _useState2[0],
      setOpenedModal = _useState2[1];

  var _useDeviceApi = useDeviceApi(),
      startForcing = _useDeviceApi.startForcing,
      stopForcing = _useDeviceApi.stopForcing,
      startVacation = _useDeviceApi.startVacation,
      stopVacation = _useDeviceApi.stopVacation;

  var activeFlags = {
    home: heatConfig.forced === "HOME",
    vacation: heatMode === "VACATION",
    pause: heatConfig.forced === "AWAY"
  };
  var isSomeActive = Object.keys(activeFlags).some(function (key) {
    return activeFlags[key];
  });
  var disabledHome = isSomeActive && !activeFlags.home;
  var disabledVacation = isSomeActive && !activeFlags.vacation;
  var disabledPause = isSomeActive && !activeFlags.pause;

  var onModalClose = function onModalClose() {
    setOpenedModal(null);
  };

  var onHomeClick = function onHomeClick() {
    setOpenedModal(activeFlags.home ? "HomeFinish" : "HomeStart");
  };

  var onPauseClick = function onPauseClick() {
    setOpenedModal(activeFlags.pause ? "PauseFinish" : "PauseStart");
  };

  var onVacationClick = function onVacationClick() {
    setOpenedModal(activeFlags.vacation ? "VacationFinish" : "VacationStart");
  };

  var onHomeForceClick = function onHomeForceClick() {
    startForcing({
      variables: {
        mode: "HOME"
      }
    });
    setOpenedModal(null);
  };

  var onPauseForceClick = function onPauseForceClick() {
    startForcing({
      variables: {
        mode: "AWAY"
      }
    });
    setOpenedModal(null);
  };

  var onUnforceClick = function onUnforceClick() {
    stopForcing();
    setOpenedModal(null);
  };

  var onVacationStartClick = function onVacationStartClick() {
    startVacation();
    setOpenedModal(null);
  };

  var onVacationStopClick = function onVacationStopClick() {
    stopVacation();
    setOpenedModal(null);
  };

  return /*#__PURE__*/React.createElement(ToggleGroupContainer, {
    manualMode: heatConfig.manual
  }, /*#__PURE__*/React.createElement(ConfirmModal, {
    isOpen: openedModal === "HomeStart",
    onClose: onModalClose,
    titleText: "Вернулись домой?",
    contentText: "Начать топить сейчас"
  }, /*#__PURE__*/React.createElement(ConfirmButton, {
    buttonLabel: "Да",
    onClick: onHomeForceClick
  }, /*#__PURE__*/React.createElement(OkayIcon, {
    width: sizeIconModal,
    height: sizeIconModal
  }))), /*#__PURE__*/React.createElement(ConfirmModal, {
    isOpen: openedModal === "HomeFinish",
    onClose: onModalClose,
    titleText: "Вернуться к графику?",
    contentText: "Возобновить работу и вернуться к работе по графику"
  }, /*#__PURE__*/React.createElement(ConfirmButton, {
    buttonLabel: "Да",
    onClick: onUnforceClick
  }, /*#__PURE__*/React.createElement(OkayIcon, {
    width: sizeIconModal,
    height: sizeIconModal
  }))), /*#__PURE__*/React.createElement(ConfirmModal, {
    isOpen: openedModal === "VacationStart",
    onClose: onModalClose,
    titleText: "Cобрались в отпуск?",
    contentText: "\u0421\u043D\u0438\u0437\u0438\u0442\u044C \u0442\u0435\u043C\u043F\u0435\u0440\u0430\u0442\u0443\u0440\u0443 \u0434\u043E ".concat(formatTemperature(heatConfig.tx.vacation), " \u043F\u043E\u043A\u0430 \u0432\u0430\u0441 \u043D\u0435\u0442?")
  }, /*#__PURE__*/React.createElement(ConfirmButton, {
    buttonLabel: "Да",
    onClick: onVacationStartClick
  }, /*#__PURE__*/React.createElement(OkayIcon, {
    height: sizeIconModal,
    width: sizeIconModal
  }))), /*#__PURE__*/React.createElement(ConfirmModal, {
    isOpen: openedModal === "VacationFinish",
    onClose: onModalClose,
    titleText: "Вернуться к графику?",
    contentText: "Возобновить работу и вернуться к работе по графику"
  }, /*#__PURE__*/React.createElement(ConfirmButton, {
    buttonLabel: "Да",
    onClick: onVacationStopClick
  }, /*#__PURE__*/React.createElement(OkayIcon, {
    width: sizeIconModal,
    height: sizeIconModal
  }))), /*#__PURE__*/React.createElement(ConfirmModal, {
    isOpen: openedModal === "PauseStart",
    onClose: onModalClose,
    titleText: "Поставить на паузу?",
    contentText: "Снизить температуру до минимального безопасного значения"
  }, /*#__PURE__*/React.createElement(ConfirmButton, {
    buttonLabel: "Да",
    onClick: onPauseForceClick
  }, /*#__PURE__*/React.createElement(OkayIcon, {
    width: sizeIconModal,
    height: sizeIconModal
  }))), /*#__PURE__*/React.createElement(ConfirmModal, {
    isOpen: openedModal === "PauseFinish",
    onClose: onModalClose,
    titleText: "Вернуться к графику?",
    contentText: "Возобновить работу и вернуться к работе по графику"
  }, /*#__PURE__*/React.createElement(ConfirmButton, {
    buttonLabel: "Да",
    onClick: onUnforceClick
  }, /*#__PURE__*/React.createElement(OkayIcon, {
    width: sizeIconModal,
    height: sizeIconModal
  }))), !heatConfig.manual && /*#__PURE__*/React.createElement(ToggleButton, {
    disabled: disabledHome,
    active: activeFlags.home,
    onClick: onHomeClick
  }, /*#__PURE__*/React.createElement(HomeIcon, {
    size: iconSize,
    fill: chooseColor(disabledHome, activeFlags.home)
  })), /*#__PURE__*/React.createElement(ToggleButton, {
    disabled: disabledVacation,
    active: activeFlags.vacation,
    onClick: onVacationClick
  }, /*#__PURE__*/React.createElement(ContainerTwoIcon, null, heatConfig.vacationSchedule && /*#__PURE__*/React.createElement(SheduleIconContainer, null, /*#__PURE__*/React.createElement(SheduleIcon, {
    size: sizeSmallIconModal,
    fill: chooseColor(disabledVacation, activeFlags.vacation)
  })), /*#__PURE__*/React.createElement(VacationIcon, {
    size: iconSize,
    fill: chooseColor(disabledVacation, activeFlags.vacation)
  }))), !heatConfig.manual && /*#__PURE__*/React.createElement(ToggleButton, {
    disabled: disabledPause,
    active: activeFlags.pause,
    onClick: onPauseClick
  }, !activeFlags.pause && /*#__PURE__*/React.createElement(PauseCircleIcon, {
    size: iconSize,
    fill: chooseColor(disabledPause, activeFlags.pause)
  }), activeFlags.pause && /*#__PURE__*/React.createElement(PauseIcon, {
    size: iconSize,
    fill: chooseColor(disabledPause, activeFlags.pause)
  })));
}